import Vue from "vue";
export default Vue.extend({
    props: {
        items: [],
    },
    data() {
        return {
            selection: null,
        };
    },
    methods: {
        async onTariffSelected(tariffId) {
            this.$emit("select", tariffId);
            await this.$nextTick();
            this.selection = null;
        },
    },
});
